import { InputWithCornerHint } from "@/shared/components/atoms/InputWithCornerHint";
import PaginationUI from "@/shared/components/atoms/PaginationUI";
import TabsUI from "@/shared/components/atoms/TabsUI";
import { DialogCreate } from "@/shared/components/molecules/DialogCreate";
import TableListTagsUser from "@/shared/components/organisms/TableListTagsUser";

import { t } from "i18next";

import { FC, useState } from "react";
import { MultiSelect } from "@/shared/components/organisms/MultiSelect";
import { useMarketingTagsQuery } from "@/app/marketing-tags/marketing-tags.api";

export const TagsUsers: FC<any> = () => {
  const marketingTagsQuery = useMarketingTagsQuery({ branchId: id, type: 2 });

  const tabs = [
    {
      name: t("brand.views.marketing_tags"),
      href: "/branchs/settings/tags",
      current: true,
    },
    {
      name: t("brand.views.user_tags_business_agreements"),
      href: "/branchs/settings/tags/users",
      current: false,
    },
  ];
  const tags = [
    {
      id: 1,
      description: "Urgent",
      color: "#FF5733",
      discount: "0%",
      fee: "Cuota 1, Cuota 2, Cuota 3, Cuota 4",
      fee_course: "Cuota 1, Cuota 2, Cuota 3, Cuota 4",
    },
    {
      id: 2,
      description: "In Progress",
      color: "#FFC300",
      discount: "20%",
      fee: "Cuota 1, Cuota 2, Cuota 3, Cuota 4",
      fee_course: "Cuota 1, Cuota 2, Cuota 3, Cuota 4",
    },
    {
      id: 3,
      description: "Completed",
      color: "#28A745",
      discount: "50%",
      fee: "Cuota 1, Cuota 2, Cuota 3, Cuota 4",
      fee_course: "Cuota 1, Cuota 2, Cuota 3, Cuota 4",
    },
    {
      id: 4,
      description: "On Hold",
      color: "#17A2B8",
      discount: "20%",
      fee: "Cuota 1, Cuota 2, Cuota 3, Cuota 4",
      fee_course: "Cuota 1, Cuota 2, Cuota 3, Cuota 4",
    },
    {
      id: 5,
      description: "Cancelled",
      color: "#DC3545",
      discount: "100%",
      fee: "Cuota 1, Cuota 2, Cuota 3, Cuota 4",
      fee_course: "Cuota 1, Cuota 2, Cuota 3, Cuota 4",
    },
    {
      id: 6,
      description: "Reviewed",
      color: "#6C757D",
      discount: "0%",
      fee: "Cuota 1, Cuota 2, Cuota 3, Cuota 4",
      fee_course: "Cuota 1",
    },
    {
      id: 7,
      description: "Pending",
      color: "#FF8C00",
      discount: "10%",
      fee: "Cuota 1",
      fee_course: "Cuota 1",
    },
    {
      id: 8,
      description: "New",
      color: "#007BFF",
      discount: "5%",
      fee: "Cuota 1, ",
      fee_course: "Cuota 1",
    },
  ];

  const optionCoutas = [
    { id: 1, name: "Cuota 1" },
    { id: 2, name: "Cuota 2" },
    { id: 3, name: "Cuota 3" },
    { id: 4, name: "Cuota 4" },
  ];

  const optionCoutasCurso = [
    { id: 1, name: "Cuota 1" },
    { id: 2, name: "Cuota 2" },
    { id: 3, name: "Cuota 3" },
    { id: 4, name: "Cuota 4" },
  ];

  const [openDialogCreate, setOpenDialogCreate] = useState(false);
  const functionOpenDialogCreate = () => {
    setOpenDialogCreate(!openDialogCreate);
  };
  const [selectCouta, setSelectCouta] = useState([]);
  const [selectCoutaCurso, setSelectCoutaCurso] = useState([]);
  return (
    <div className="flex flex-col items-center justify-center h-full w-full mt-8">
      <div className="w-full sm:max-w-full md:max-w-full lg:max-w-full xl:max-w-full 2xl:max-w-full mx-auto mb-8">
        <div className="px-4">
          <TabsUI tabs={tabs} />
        </div>
        <TableListTagsUser
          tagsUser={marketingTagsQuery.data ?? []}
          OnclickTop={functionOpenDialogCreate}
        />
        <PaginationUI
          currentPage={1}
          totalPages={1}
          onPageChange={() => {}}
          pageSize={1}
          totalResults={1}
        />
        <DialogCreate
          open={openDialogCreate}
          setOpen={functionOpenDialogCreate}
          tittle={t("brand.views.create_user_tag_agreements")}
          OnclickCreate={() => {}}
          OnclickCancel={functionOpenDialogCreate}
          tittleButtonCreate={t("general.create")}
          tittleButtonCancel={t("general.cancel")}
        >
          <form action="">
            <div className="mt-6 mx-2">
              <div className="space-y-12">
                <div className="grid grid-cols-1 gap-x-8 gap-y-10 pb-12 md:grid-cols-3 border-b border-gray-900/10">
                  <div className="flex items-center justify-center h-full text-center">
                    <div>
                      <h2 className="text-base font-semibold leading-7 text-gray-900">
                        {t("brand.views.caracteristics_tag")}
                      </h2>
                    </div>
                  </div>
                  <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2">
                    <div className="col-span-full">
                      <InputWithCornerHint
                        label={t("brand.views.tag_name")}
                        type="text"
                        placeholder={t("brand.views.tag_name")}
                      />
                    </div>
                    <div className="col-span-full">
                      <InputWithCornerHint
                        label={t("brand.views.discount")}
                        type="number"
                        placeholder={t("brand.views.discount")}
                      />
                    </div>
                    <div className="col-span-full">
                      <InputWithCornerHint
                        label={t("brand.views.color")}
                        type="color"
                      />
                    </div>
                  </div>
                </div>
                <div className="grid grid-cols-1 gap-x-8 gap-y-10 pb-12 md:grid-cols-3 border-b border-gray-900/10">
                  <div className="flex items-center justify-center h-full text-center">
                    <div>
                      <h2 className="text-base font-semibold leading-7 text-gray-900">
                        {t("brand.views.info_comercial")}
                      </h2>
                    </div>
                  </div>
                  <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2">
                    <div className="col-span-full">
                      <InputWithCornerHint
                        label={t("brand.views.business_name")}
                        type="text"
                        placeholder={t("brand.views.business_name")}
                      />
                    </div>
                    <div className="col-span-full">
                      <InputWithCornerHint
                        label={t("brand.views.trade_name")}
                        type="text"
                        placeholder={t("brand.views.trade_name")}
                      />
                    </div>
                    <div className="col-span-full">
                      <InputWithCornerHint
                        label={t("brand.views.tax_id")}
                        type="text"
                        placeholder={t("brand.views.tax_id")}
                      />
                    </div>
                    <div className="col-span-full">
                      <InputWithCornerHint
                        label={t("brand.views.postal_code")}
                        type="number"
                        placeholder={t("brand.views.postal_code")}
                      />
                    </div>
                    <div className="col-span-full">
                      <InputWithCornerHint
                        label={t("brand.views.address")}
                        type="text"
                        placeholder={t("brand.views.address")}
                      />
                    </div>
                    <div className="col-span-full">
                      <InputWithCornerHint
                        label={t("brand.views.number")}
                        type="number"
                        placeholder={t("brand.views.number")}
                      />
                    </div>
                    <div className="col-span-full">
                      <InputWithCornerHint
                        label={t("brand.views.floor_apartment")}
                        type="text"
                        placeholder={t("brand.views.floor_apartment")}
                      />
                    </div>
                    <div className="col-span-full">
                      <InputWithCornerHint
                        label={t("brand.views.district_locality")}
                        type="text"
                        placeholder={t("brand.views.district_locality")}
                      />
                    </div>
                    <div className="col-span-full">
                      <InputWithCornerHint
                        label={t("brand.views.city")}
                        type="text"
                        placeholder={t("brand.views.city")}
                      />
                    </div>
                    <div className="col-span-full">
                      <InputWithCornerHint
                        label={t("brand.views.province")}
                        type="text"
                        placeholder={t("brand.views.province")}
                      />
                    </div>
                    <div className="col-span-full">
                      <InputWithCornerHint
                        label={t("brand.views.responsible")}
                        type="text"
                        placeholder={t("brand.views.responsible")}
                      />
                    </div>
                    <div className="col-span-full">
                      <InputWithCornerHint
                        label={t("brand.views.email")}
                        type="email"
                        placeholder={t("brand.views.email")}
                      />
                    </div>
                    <div className="col-span-full">
                      <InputWithCornerHint
                        label={t("brand.views.financial_email")}
                        type="email"
                        placeholder={t("brand.views.financial_email")}
                      />
                    </div>
                  </div>
                </div>
                <div className="grid grid-cols-1 gap-x-8 gap-y-10 pb-12 md:grid-cols-3">
                  <div className="flex items-center justify-center h-full text-center">
                    <div>
                      <h2 className="text-base font-semibold leading-7 text-gray-900">
                        {t("brand.views.discounts")}
                      </h2>
                    </div>
                  </div>
                  <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2">
                    <div className="col-span-full">
                      <MultiSelect
                        title={t("brand.views.fees")}
                        selectedOptions={selectCouta}
                        setSelectedOptions={setSelectCouta}
                        options={optionCoutas}
                      />
                    </div>
                    <div className="col-span-full">
                      <MultiSelect
                        title={t("brand.views.course_fees")}
                        selectedOptions={selectCoutaCurso}
                        setSelectedOptions={setSelectCoutaCurso}
                        options={optionCoutasCurso}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </DialogCreate>
      </div>
    </div>
  );
};
